import styled from "styled-components";

import {
  alignItemsCenter,
  flexColumn,
  marginInlineAuto,
  rem,
} from "@styles/Utilities.styled";


export const StyledErrorPage = styled.section`
  height: 100vh;

  .content {
    ${flexColumn}
    justify-content: center;
    gap: 3rem;
    height: 100%;
  }

  .illustration {
    ${marginInlineAuto(`min(70%, ${rem(450)})`)}
  }

  .text-content {
    ${flexColumn}
    align-items: center;
    gap: 0.5rem;
    max-width: 60ch;
    margin-inline: auto;
    text-align: center;

    h1 {
      font-weight: 500;
    }

    p {
      color: var(--clr-gray-400);
      font-size: ${rem(14)};
      line-height: 1.2;
    }

    .cta {
      ${alignItemsCenter}
      gap: 0.5rem;
      width: fit-content;
      margin: 1rem auto 0;
    }
  }
`;
